import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const CurrencyContext = createContext(null);

export const useCurrency = () => {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error('useCurrency must be inside CurrencyProvider');
  return ctx;
};

const RATES = { USD: 1, EUR: 0.92, GBP: 0.79, CAD: 1.36, AUD: 1.53 };
const SYMBOLS = { USD: '$', EUR: '\u20AC', GBP: '\u00A3', CAD: 'C$', AUD: 'A$' };
const COUNTRY_MAP = { US: 'USD', GB: 'GBP', DE: 'EUR', FR: 'EUR', ES: 'EUR', IT: 'EUR', CA: 'CAD', AU: 'AUD' };

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrencyState] = useState(() => localStorage.getItem('cs_currency') || 'USD');

  useEffect(() => {
    if (localStorage.getItem('cs_currency')) return;
    fetch('https://ipapi.co/json/')
      .then(r => r.json())
      .then(data => {
        const detected = COUNTRY_MAP[data.country_code] || 'USD';
        setCurrencyState(detected);
        localStorage.setItem('cs_currency', detected);
      })
      .catch(() => {});
  }, []);

  const setCurrency = useCallback((c) => {
    setCurrencyState(c);
    localStorage.setItem('cs_currency', c);
  }, []);

  const formatPrice = useCallback((amount, curr) => {
    const c = curr || currency;
    const symbol = SYMBOLS[c] || '$';
    const rate = RATES[c] || 1;
    return `${symbol}${(amount * rate).toFixed(2)}`;
  }, [currency]);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, formatPrice, currencies: Object.keys(RATES), symbols: SYMBOLS }}>
      {children}
    </CurrencyContext.Provider>
  );
};
